import $ from 'jquery'

import ApplicationController from '../application_controller'

export default class extends ApplicationController {
  static targets = ['mwh', 'hint', 'price', 'direction']

  direction = { SELL: 'Salg', BUY: 'Kjøp' }

  connect() {
    const produksjonstimeCell = this.element.querySelectorAll('.openmodal')
    const modal = document.querySelector('#myModal')
    const ordreButton = document.querySelector('#legg-inn-ordre-button')
    const exclusionElement = document.querySelector('#outside')
    const modalTitle = document.querySelector('.modal-title')
    const price_areaSelect = document.querySelector('#price_area')
    const portfolioSelect = document.querySelector('#portfolio')

    ordreButton.disabled = true

    if (this.hasMwhTarget) {
      this.mwhTarget.addEventListener('input', () =>
        this.validateForm(ordreButton)
      )
      this.priceTarget.addEventListener('input', () =>
        this.validateForm(ordreButton)
      )
    }

    produksjonstimeCell.forEach((cell) => {
      cell.addEventListener('click', function (event) {
        const cellValue = event.currentTarget
          .querySelector('.prod_hour')
          .textContent.trim() // Assuming the value is text content
        const contractIdValue = event.currentTarget
          .querySelector('.contract_id')
          .textContent.trim()
        const timestampValue = event.currentTarget
          .querySelector('.timestamp')
          .textContent.trim()
        const selectedprice_area =
          price_areaSelect.options[price_areaSelect.selectedIndex].text
        const selectedPortfolio =
          portfolioSelect.options[portfolioSelect.selectedIndex].text
        const selectedPortfolioId =
          portfolioSelect.options[portfolioSelect.selectedIndex].value
        modalTitle.textContent = `Produksjonstime for ${cellValue} for portfolio ${selectedPortfolio} in ${selectedprice_area}`
        modal.classList.remove('hidden')
        $('#contract-id-field').val(contractIdValue)
        $('#price-area-field').val(selectedprice_area)
        $('#timestamp-field').val(timestampValue)
        $('#portfolio-field').val(selectedPortfolioId)
        $('#contract-id-field')

        // Use Ajax to trigger a server-side action

        $.ajax({
          url: `/intraday/order_books?price_area=${$('#price-area-field').val()}&contract_id=${$('#contract-id-field').val()}`, // Replace with your Rails route
          cache: false, // Disable caching: reason not sure if constant top10 or not reloading , now they look different
          type: 'GET',
          success: function (data) {
            // Update the modal content or perform other actions based on the server's response
            updateModalContent(data)
          },
          error: function () {
            console.error('Failed to fetch order book contract details ')
          }
        })

        // Show the modal (replace with your modal show logic)
        modal.classList.remove('hidden')
      })
    })

    function updateModalContent(data) {
      // Update the modal content based on the server's response
      const modalContent = modal.querySelector('.order_book')
      const details_buys = data['book_orders'][0]['buys']
      const details_sells = data['book_orders'][1]['sells']

      // Clear existing content
      modalContent.innerHTML = ''

      const maxLength = Math.max(details_buys.length, details_sells.length)

      for (let index = 0; index < maxLength; index++) {
        const tr = document.createElement('tr')
        tr.className = 'divide-x divide-gray-400'

        const tdQtyBuy = document.createElement('td')
        tdQtyBuy.className = 'whitespace-nowrap p-2 text-sm text-gray-950'
        tdQtyBuy.textContent = details_buys[index]
          ? details_buys[index].qty / 1000.0
          : ''

        const tdPriceBuy = document.createElement('td')
        tdPriceBuy.className = 'whitespace-nowrap p-2 text-sm text-gray-950'
        tdPriceBuy.textContent = details_buys[index]
          ? details_buys[index].price / 100.0
          : ''

        const tdPriceSell = document.createElement('td')
        tdPriceSell.className = 'whitespace-nowrap p-2 text-sm text-gray-950'
        tdPriceSell.textContent = details_sells[index]
          ? details_sells[index].price / 100.0
          : ''

        const tdQtySell = document.createElement('td')
        tdQtySell.className = 'whitespace-nowrap p-2 text-sm text-gray-950'
        tdQtySell.textContent = details_sells[index]
          ? details_sells[index].qty / 1000.0
          : ''

        // Append the created elements to the row
        tr.appendChild(tdQtyBuy)
        tr.appendChild(tdPriceBuy)
        tr.appendChild(tdPriceSell)
        tr.appendChild(tdQtySell)
        // Append the row to the table
        modalContent.appendChild(tr)
      }
    }

    modal.addEventListener('click', function (event) {
      if (!exclusionElement.contains(event.target)) {
        modal.classList.add('hidden') // hide the modal when clicking outside of it
      }
    })
  }

  async confirmOrder(event) {
    event.preventDefault()
    const orderDetails = this.getOrderDetailsHtml()
    const direction = this.directionTarget.value
    const titleDetails = 'Bekreft ordredetaljer'
    const buttonText = 'Bekreft ' + this.direction[direction].toLowerCase()
    const buttonColor = direction === 'BUY' ? 'green' : 'pink'
    const confirm = await this.confirmDialog(
      titleDetails,
      orderDetails,
      buttonColor,
      buttonText
    )

    if (confirm) {
      const form = event.target.closest('form')
      if (form) {
        form.submit()
      }
    }
  }

  getOrderDetailsHtml() {
    const price = this.priceTarget.value
    const volume = this.mwhTarget.value
    const total = price * volume
    const direction = this.direction[this.directionTarget.value]

    return `
        <span class="grid grid-cols-1 gap-2 bg-gray-50 rounded-md ring-gray-400 p-4 text-center">
          <span class="${direction === 'Kjøp' ? 'text-green-500' : 'text-pink-500'} font-bold text-xl">
            ${direction}
          </span>
          <span class="grid grid-cols-3">
            <span>
              <p class="text-xs">Pris/MWh</p>
              <span class="flex inline-flex font-bold stroke-blue-900 text-blue-900 gap-1">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.25 7.75625C12.667 7.19798 10.8341 7.5519 9.56802 8.81802C7.81066 10.5754 7.81066 13.4246 9.56802 15.182C10.8341 16.4481 12.667 16.802 14.25 16.2437M7.5 10.5H12.75M7.5 13.5H12.75M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p class="">${price} EUR</p>        
              </span>
            </span>
            <span>
              <p class="text-xs">Volum</p>
              <span class="flex inline-flex font-bold stroke-blue-900 text-blue-900 gap-1">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.75 13.5L14.25 2.25L12 10.5H20.25L9.75 21.75L12 13.5H3.75Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p class="">${volume} MWh</p>              
              </span>
            </span>
            <span>
                <p class="text-xs">Total</p>
                <span class="flex inline-flex font-bold stroke-blue-900 text-blue-900 gap-1">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.25 7.75625C12.667 7.19798 10.8341 7.5519 9.56802 8.81802C7.81066 10.5754 7.81066 13.4246 9.56802 15.182C10.8341 16.4481 12.667 16.802 14.25 16.2437M7.5 10.5H12.75M7.5 13.5H12.75M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p class="">${total.toFixed(2)}</p>        
              </span>       
            </span>
          </span>
        </span>    
`
  }

  validateForm(orderButton) {
    orderButton.disabled = this.validatePrice() || this.validateMaxMwh()
  }

  validateMaxMwh() {
    const selectedOption =
      document.getElementById('portfolio').selectedOptions[0]
    const maxAllowed = parseFloat(selectedOption.dataset.maxMwh)
    const currentValue = parseFloat(this.mwhTarget.value)
    if (!currentValue) return true

    if (this.hasHintTarget) {
      if (currentValue > maxAllowed) {
        this.hintTarget.classList.add('text-red-500')
        this.hintTarget.textContent = `Må være mindre enn ${maxAllowed} MWh`
        return true
      } else {
        this.hintTarget.classList.remove('text-red-500')
        this.hintTarget.textContent = ''
        return false
      }
    }
  }

  validatePrice() {
    const price = parseFloat(this.priceTarget.value)
    return isNaN(price)
  }
}
